import { render } from "./HomePage.vue?vue&type=template&id=090bfe5a&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=090bfe5a&lang=less&scoped=true"
import "./HomePage.vue?vue&type=style&index=1&id=090bfe5a&lang=less&scoped=true"
import "./HomePage.vue?vue&type=style&index=2&id=090bfe5a&lang=less&scoped=true"
import "./HomePage.vue?vue&type=style&index=3&id=090bfe5a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090bfe5a"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QParallax from 'quasar/src/components/parallax/QParallax.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QParallax,QBtn,QSeparator,QImg});
